module.exports = __webpack_public_path__ + "img/010-tablet.7bc88c6c.svg";